<mat-dialog-content *ngIf="!isLoading">
    <h2 style="text-align: center">{{data.title}}</h2>
  
    {{data.message}}
  
    <div *ngIf="data.messageCentered; else notCentered">
      <div *ngFor="let msg of data.messageArray" style="text-align: center">
          {{msg}}
      </div>
    </div>
    <ng-template #notCentered>
      <div *ngFor="let msg of data.messageArray">
          {{msg}}
      </div>
    </ng-template>
    <br><br>
    <div [ngSwitch]="data.mode" style="text-align: center">
      <!-- OK -->
      <div *ngSwitchCase="ConfirmDialogMode.OK" class="call-button-container">
        <gux-button accent="primary" class="call-button" type="button" (click)="closeDialog(true)" (keypress)="closeDialog(true)">OK</gux-button>
      </div>
      <!-- Yes / No -->
      <div *ngSwitchCase="ConfirmDialogMode.YES_NO" class="call-button-container">
        <gux-button accent="primary" class="call-button" type="button" (click)="closeDialog(true)" (keypress)="closeDialog(true)">Yes</gux-button>
        <gux-button accent="primary" class="call-button" type="button" (click)="closeDialog(false)" (keypress)="closeDialog(false)">No</gux-button>
      </div>
      <!-- Save / Cancel -->
      <div *ngSwitchCase="ConfirmDialogMode.SAVE_CANCEL" class="call-button-container">
        <gux-button accent="primary" class="call-button" type="button" (click)="closeDialog(true)" (keypress)="closeDialog(true)">Save</gux-button>
        <gux-button accent="primary" class="call-button" (click)="closeDialog(false)" (keypress)="closeDialog(false)">Cancel</gux-button>
      </div>
      <!-- Delete / Cancel -->
      <div *ngSwitchCase="ConfirmDialogMode.DELETE_CANCEL" class="call-button-container">
        <gux-button accent="primary" class="call-button" type="button" (click)="closeDialog(true)" (keypress)="closeDialog(true)">Delete</gux-button>
        <gux-button accent="primary" class="call-button"type="button" (click)="closeDialog(false)" (keypress)="closeDialog(false)">Cancel</gux-button>
      </div>
      <!-- Discard / Cancel -->
      <div *ngSwitchCase="ConfirmDialogMode.DISCARD_CANCEL" class="call-button-container">
        <gux-button accent="primary" class="call-button" color="warn" type="button" (click)="closeDialog(true)" (keypress)="closeDialog(true)">Discard</gux-button>
        <gux-button accent="primary" class="call-button" color="accent" type="button" (click)="closeDialog(false)" (keypress)="closeDialog(false)">Cancel</gux-button>
      </div>
    </div>
  
  </mat-dialog-content>
    